import styles from './styles.module.scss'
import userDefault from '../../../assets/imagenes/userDefault.svg'
import PrivateImg from '@shared/componets/ui/Img/variant/ImgPrivate/ImgPrivate';

const Header = ({ nombre, apellido, img = '', loading, active }) => {

	return (
		<header className={`${styles.headerLayout} ${active ? '' : styles.headerLayoutDiseable}`}>
			<div className={styles['headerLayout-content']}>
				<h2 className={styles.name}>{loading ? "Cargando ..." : `${nombre} ${apellido}`}</h2>
				<PrivateImg
					classNameContent={styles.user}
					className={styles['headerLayout-content-user-img']}
					src={img}
					alt={"imagen de usuario " + nombre}
					imgDefault={userDefault}
				/>
			</div>
		</header>
	)
}

export default Header;
